import styledComponents from "styled-components";

const Container = styledComponents.div`
        margin: 0 auto;
        width: 100%;
        max-width : ${props => props.maxWidth || "1440px"};
`

export default Container;
